__turbopack_context__.v({
  "header": "Header-module-scss-module__rIun6a__header",
  "headerScrolled": "Header-module-scss-module__rIun6a__headerScrolled",
  "languageItem": "Header-module-scss-module__rIun6a__languageItem",
  "languageLink": "Header-module-scss-module__rIun6a__languageLink",
  "languageList": "Header-module-scss-module__rIun6a__languageList",
  "languageSwitcher": "Header-module-scss-module__rIun6a__languageSwitcher",
  "livePlayerButton": "Header-module-scss-module__rIun6a__livePlayerButton",
  "logo": "Header-module-scss-module__rIun6a__logo",
  "logoLink": "Header-module-scss-module__rIun6a__logoLink",
  "nav": "Header-module-scss-module__rIun6a__nav",
  "navItem": "Header-module-scss-module__rIun6a__navItem",
  "navLink": "Header-module-scss-module__rIun6a__navLink",
  "navList": "Header-module-scss-module__rIun6a__navList",
  "navOptions": "Header-module-scss-module__rIun6a__navOptions",
  "searchButton": "Header-module-scss-module__rIun6a__searchButton",
  "themeToggleButton": "Header-module-scss-module__rIun6a__themeToggleButton",
  "toggleMenu": "Header-module-scss-module__rIun6a__toggleMenu",
  "top": "Header-module-scss-module__rIun6a__top",
  "top__container": "Header-module-scss-module__rIun6a__top__container",
});
